<template>
  <div class="pa-8 text-center grey--text">
    <v-icon size="40" color="grey lighten-1">mdi-home-analytics</v-icon>
    <div class="mt-2">
      Esta sección fue reorganizada: "Uso por empresa" ahora está en
      <strong>Métricas → Customer Success</strong>, y el reporte por empresa se ve al
      hacer clic en una empresa dentro de <strong>General → Empresas</strong>.
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataView',
};
</script>
